import { AnyAction } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import detaisSlice from "./slices/game-details";
import selectorsSlice from "./slices/selectors";
import modalsSlice from "./slices/modals";
import buttonsSlice from "./slices/buttons";
import layoutSlice from "./slices/layout";
import errorSlice from "./slices/error";
import loadingScreenSlice from "./slices/loading-screen";
import historySlice from "./slices/history";
import messagesSlice from "./slices/messages";
import freeRoundsSlices from "./slices/free-rounds";
import realityCheck from "./slices/reality-check";
import animations from "./slices/animations";
import theme from "./slices/theme";
import buyBonus from "./slices/buy-bonus";
import autoplay from "./slices/autoplay";
import soundsOverlay from "./slices/sound-overlay";
import spinnerOverlay from "./slices/spinner-overlay";
import previousWin from "./slices/previous-win";

const store = configureStore({
  reducer: {
    details: detaisSlice.reducer,
    selectors: selectorsSlice.reducer,
    modals: modalsSlice.reducer,
    buttons: buttonsSlice.reducer,
    layout: layoutSlice.reducer,
    error: errorSlice.reducer,
    loadingScreen: loadingScreenSlice.reducer,
    history: historySlice.reducer,
    messages: messagesSlice.reducer,
    freeRounds: freeRoundsSlices.reducer,
    animations: animations.reducer,
    realityCheck: realityCheck.reducer,
    theme: theme.reducer,
    buyBonus: buyBonus.reducer,
    autoplay: autoplay.reducer,
    soundsOverlay: soundsOverlay.reducer,
    previousWin: previousWin.reducer,
    spinnerOverlay: spinnerOverlay.reducer
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;
